import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { detailPostInterface } from '../../types/post.type';

interface PostState {
  viewedHistory: detailPostInterface[]; // Lịch sử đã xem
  savedPosts: detailPostInterface[];   // Nội dung đã lưu
  likedPosts: detailPostInterface[];   // Danh sách đã thích
}

const initialState: PostState = {
  viewedHistory: [],
  savedPosts: [],
  likedPosts: [],
};

const postSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {
    addToHistory(state, action: PayloadAction<detailPostInterface>) {
      // Thêm vào lịch sử, loại bỏ trùng lặp theo id
      const exists = state.viewedHistory.find(item => item.id === action.payload.id);
      if (!exists) {
        state.viewedHistory.unshift(action.payload);
      } else {
        // Nếu đã có, cập nhật thông tin like nếu có
        const updated = { ...exists, ...action.payload };
        state.viewedHistory = [updated, ...state.viewedHistory.filter(item => item.id !== action.payload.id)];
      }
      // Giới hạn lịch sử tối đa 50 mục
      if (state.viewedHistory.length > 50) {
        state.viewedHistory = state.viewedHistory.slice(0, 50);
      }
    },
    clearHistory(state) {
      state.viewedHistory = [];
    },
    savePost(state, action: PayloadAction<any>) {
      if (!state.savedPosts.find(item => item.id === action.payload.id)) {
        state.savedPosts.unshift(action.payload);
      }
    },
    removeSavedPost(state, action: PayloadAction<string | number>) {
      state.savedPosts = state.savedPosts.filter(item => item.id !== action.payload);
    },
    clearSaved(state) {
      state.savedPosts = [];
    },
    likePost(state, action: PayloadAction<any>) {
      if (!state.likedPosts.find(item => item.id === action.payload.id)) {
        state.likedPosts.unshift(action.payload);
      }
    },
    unlikePost(state, action: PayloadAction<string | number>) {
      state.likedPosts = state.likedPosts.filter(item => item.id !== action.payload);
    },
    clearLiked(state) {
      state.likedPosts = [];
    },
  },
});

export const { addToHistory, clearHistory, savePost, removeSavedPost, clearSaved, likePost, unlikePost, clearLiked } = postSlice.actions;
export default postSlice.reducer;
